export const navigatorLanguageToLocale = (navigatorLanguage: string) => {
  switch (navigatorLanguage) {
    case 'en':
      return 'en_US';
    case 'es':
      return 'es_ES';
    case 'fr':
      return 'fr_FR';
    case 'de':
      return 'de_DE';
    case 'it':
      return 'it_IT';
    case 'pt':
      return 'pt_PT';
    default:
      return 'en_US';
  }
};
